import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import SEO from "./SEO";
import {
  LayoutDashboard,
  Boxes,
  Tags,
  Package,
  MapPin,
  FileText,
  Newspaper,
  Home,
  Settings,
  LogOut,
  Mail,
  FileEdit,
  HardDrive,
} from "lucide-react";

const ITEMS = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/brands", icon: Boxes, label: "Brands" },
  { to: "/admin/categories", icon: Tags, label: "Categories" },
  { to: "/admin/products", icon: Package, label: "Products" },
  { to: "/admin/dealers", icon: MapPin, label: "Dealers" },
  { to: "/admin/manuals", icon: FileText, label: "Manuals" },
  { to: "/admin/downloads", icon: HardDrive, label: "Downloads" },
  { to: "/admin/blog", icon: Newspaper, label: "Blog" },
  { to: "/admin/homepage", icon: Home, label: "Homepage Content" },
  { to: "/admin/pages", icon: FileEdit, label: "Pages Content" },
  { to: "/admin/settings", icon: Settings, label: "Site Settings" },
  { to: "/admin/submissions", icon: Mail, label: "Submissions" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const pageTitle =
    ITEMS.find((it) => it.to === location.pathname)?.label ||
    (location.pathname === "/admin" ? "Dashboard" : "Admin");

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white flex">
      <SEO admin title={pageTitle} />
      <aside className="w-64 border-r border-white/10 bg-[#0A0A0A] flex flex-col" data-testid="admin-sidebar">
        <div className="p-6 border-b border-white/10">
          <div className="font-display text-xl font-semibold tracking-tight">Noon Foto</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">Admin Panel</div>
        </div>

        <nav className="flex-1 py-4 px-2 overflow-y-auto">
          {ITEMS.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 my-0.5 text-sm rounded transition-colors ${
                  isActive
                    ? "text-white bg-white/5 border-l-2"
                    : "text-zinc-400 hover:text-white hover:bg-white/5 border-l-2 border-transparent"
                }`
              }
              style={({ isActive }) => (isActive ? { borderLeftColor: "var(--brand-primary)" } : {})}
              data-testid={`sidebar-link-${it.label.toLowerCase().replace(/ /g, "-")}`}
            >
              <it.icon size={16} />
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/10">
          <div className="text-xs text-zinc-500 mb-2">{user?.email}</div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 text-xs uppercase tracking-[0.2em] py-2 border border-white/10 hover:border-white/30 transition-colors"
            data-testid="admin-logout-btn"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto">
        <div className="p-8 max-w-7xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
